document.addEventListener('DOMContentLoaded', function() {

    const el = document.getElementById('benefits');
    
    const init = function() {
        const item = el.getElementsByClassName('js-item'),
              more = el.getElementsByClassName('js-more');
        
        const show = function(e) {
            const _this = e.currentTarget;

            for (let j = 0; j < item.length; j++) {
                item[j].classList.remove('is-active');
            }                
            _this.classList.add('is-active');
            
        };
        
        const hide = function(e) {
            for (let j = 0; j < item.length; j++) {
                item[j].classList.remove('is-active');
            }
        };
        
        for (let i = 0; i < item.length; i++) {
            item[i].addEventListener('click', show);
        }
        
        for (let i = 0; i < item.length; i++) {
            more[i].addEventListener('click', hide);
        }
        
        const clickOutside = function(e) {
            e.target.closest('.js-item') === null ? hide() : false
        };
        
        document.addEventListener('click', clickOutside);
    };

    el ? init() : false;

}, false);